"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VrcWebUserPageLinkButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_1 = require("react");
exports.VrcWebUserPageLinkButton = (0, react_1.memo)(function VrcWebUserPageLinkButton(_a) {
    var id = _a.id;
    return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { icon: true, size: "mini", as: "a", href: "https://vrchat.com/home/user/".concat(id), target: "_blank", children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "external" }) }));
});
